import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getallmodules = async (params) => {
  const { selectedTrainingtype, selectedUsertype, selectedLanguage } = params;
  let response = await api.get("getAllModules/" + selectedTrainingtype + "/" + selectedUsertype + "/" + selectedLanguage);
  return response.data;
};

export const getallsubmodules = async (params) => {
  const { selectedTrainingtype, selectedUsertype, selectedLanguage, selectedModule } = params;
  let response = await api.get("getAllSubmodulesByModuleid/" + selectedTrainingtype + "/" + selectedUsertype + "/" + selectedLanguage + "/" + selectedModule);
  return response.data;
};

export const getalltopics = async (params) => {
  const { selectedTrainingtype, selectedUsertype, selectedLanguage, selectedModule, selectedSubmodule } = params;
  let response = await api.get("getAllTopicsBySubmoduleid/" + selectedTrainingtype + "/" + selectedUsertype + "/" + selectedLanguage + "/" + selectedModule + "/" + selectedSubmodule);
  return response.data;
};

export const getalldata = async (params) => {
  const { selectedUsertype, selectedTrainingtype, selectedModule, selectedSubmodule, selectedTopic } = params;
  let response = await api.get("getContentsAndQuizByTopicid/" + selectedUsertype + "/" + selectedTrainingtype + "/" + selectedModule + "/" + selectedSubmodule + "/" + selectedTopic);
  return response.data;
};

export const updateassignmentquestion = async (reqbody) => {
  //const id = reqbody._id;
  //const body = reqbody.body;
  console.log(" id and body: ", reqbody);
  let response = await api.put("updateMasterContentQuizData", reqbody);
  return response.data;
};
